import styled from "styled-components";
import { Alert } from "react-bootstrap";

export const MainWrapper = styled.div`
  min-height: 100vh;
  background: #f6f7fb;
  padding: 24px 0;

  @media (max-width: 576px) {
    padding: 16px 0;
  }
`;

export const MainContent = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 30px;
  margin-top: 18px;
  border: 1px solid #eaecf0;
  box-shadow: 0 10px 30px rgba(16, 24, 40, 0.08);
  position: relative;
  overflow: hidden;

  /* detalhe “premium” bem sutil */
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #2563eb, #7c3aed);
    opacity: 0.85;
  }

  @media (max-width: 576px) {
    padding: 18px;
    border-radius: 14px;
  }

  /* Bootstrap controls refinados sem mexer em dependências */
  .form-control {
    border-radius: 12px;
    height: 44px;
    padding: 10px 12px;
    border: 1px solid #e4e7ec;
    box-shadow: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  }

  .form-control:focus {
    border-color: #7c3aed;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12);
  }

  select.form-control {
    padding-right: 36px;
  }

  /* placeholder vs valor selecionado */
  .form-control.is-placeholder {
    color: #98a2b3;
  }
  .form-control.has-value {
    color: #101828;
  }

  /* badge do plano (Badge do bootstrap com classe plan-badge) */
    .plan-badge {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0.2px;
    padding: 7px 12px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.35);
    box-shadow: 0 6px 18px rgba(16, 24, 40, 0.10);
    align-self: center;
    white-space: nowrap;
  }

  @media (max-width: 576px) {
    .plan-badge {
      font-size: 12px;
      padding: 6px 10px;
    }
  }


  .btn-primary {
    border-radius: 14px;
    padding: 6px 14px;
    min-height: 44px;
    font-weight: 600;
    transition: transform 0.12s ease, box-shadow 0.12s ease;
  }

  .btn-primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 10px 20px rgba(16, 24, 40, 0.14);
  }

  .btn:disabled,
  .btn.disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const TopMessageArea = styled.div`
  margin-bottom: 6px;
`;

export const TopAlert = styled(Alert)`
  border-radius: 12px;
  border: 1px solid #eaecf0;
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const HeaderText = styled.div`
  width: 100%;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    align-items: flex-start;
  }
`;

export const Title = styled.h3`
  margin: 0;
  font-weight: 550;
  letter-spacing: -0.4px;
  color: #101828;
  line-height: 1.15;

  @media (max-width: 576px) {
    font-size: 20px;
  }
`;

export const Subtitle = styled.p`
  margin: 8px 0 0 0;
  color: #667085;
  line-height: 1.5;
  max-width: 860px;

  @media (max-width: 576px) {
    font-size: 13px;
  }
`;

export const SectionCard = styled.div`
  border: 1px solid #eaecf0;
  border-radius: 16px;
  padding: 18px;
  margin-top: 16px;
  background: #fff;

  @media (max-width: 576px) {
    padding: 14px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
`;

export const SectionTitle = styled.div`
  font-weight: 500;
  color: #101828;
`;

export const SectionHint = styled.div`
  margin-top: 4px;
  font-size: 12.5px;
  color: #667085;
`;

export const FieldLabel = styled(FormLabel)`
  font-weight: 500;
  color: #101828;
  margin-bottom: 6px;

  .required {
    color: #d92d20;
  }
`;

/* Pequeno helper para manter o padrão de label mesmo sem usar Form.Label */
function FormLabel({ className, children }) {
  return <div className={className}>{children}</div>;
}

export const HelpText = styled.div`
  margin-top: 6px;
  font-size: 12.5px;
  color: #667085;
`;

export const FieldError = styled.div`
  margin-top: 8px;
  font-size: 12.5px;
  color: #d92d20;
  font-weight: 700;
`;

export const Dropzone = styled.div`
  border: 1.8px dashed rgba(124, 58, 237, 0.55);
  border-radius: 16px;
  padding: 18px;
  cursor: pointer;
  transition: transform 0.12s ease, border-color 0.12s ease, background 0.12s ease, box-shadow 0.12s ease;
  background: #fbfaff;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(124, 58, 237, 0.9);
    background: #f7f4ff;
    box-shadow: 0 10px 22px rgba(16, 24, 40, 0.08);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.14);
  }

    &[data-hasfile="true"] {
    border-color: rgba(2, 122, 72, 0.35);
    background: #fbfffd;
  }

  @media (max-width: 576px) {
    padding: 14px;
  }
`;

export const DropzoneInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;

  text-align: center;
  padding: 8px 10px;

  @media (max-width: 576px) {
    padding: 6px 6px;
  }
`;

export const DropIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: rgba(124, 58, 237, 0.12);
  color: #5b21b6;

  @media (max-width: 576px) {
    width: 44px;
    height: 44px;
    border-radius: 14px;
  }
`;


export const DropTitle = styled.div`
  font-weight: 700;
  color: #101828;
  line-height: 1.2;
`;

export const DropSub = styled.div`
  margin-top: 2px;
  font-size: 12.5px;
  color: #667085;
`;

export const DropMuted = styled.div`
  margin-top: 6px;
  font-size: 12.5px;
  color: #98a2b3;
`;

export const FileRow = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const FileCenter = styled.div`
  display: flex;
  justify-content: center;
`;


export const FileChip = styled.div`
  max-width: 100%;
  display: flex;
  align-items: center;
  margin-left: 0;
  gap: 8px;

  /* bem mais discreto */
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid rgba(2, 122, 72, 0.18);
  background: rgba(2, 122, 72, 0.06);
  color: #05603a;

  .label {
    font-size: 12px;
    font-weight: 600;
    color: #027a48;
    white-space: nowrap;
  }

  .name {
    font-size: 12px;
    font-weight: 600;
    color: #05603a;

    /* segura nomes gigantes */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 460px;
  }

    &.stack {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;

    .label,
    .name {
      line-height: 1.2;
    }
  }

  @media (max-width: 576px) {
    padding: 6px 8px;

    .name {
      max-width: 230px;
    }
  }
`;

export const PreviewWrap = styled.div`
  margin-top: 14px;
`;

export const PreviewTitle = styled.h6`
  margin: 5px 0 10px 0; /* Top -> Right -> Bottom -> Left */
  font-weight: 550;
  color: #101828;
`;

export const PreviewBox = styled.div`
  border: 1px solid #eaecf0;
  border-radius: 16px;
  padding: 12px;
  background: #f9fafb;

  img {
    width: 100%;
    height: auto;
    border-radius: 12px;
    display: block;
  }
`;

export const PreviewMeta = styled.div`
  margin-top: 8px;
  font-size: 12.5px;
  color: #667085;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Actions = styled.div`
  display: grid;
  place-items: center;
  margin-top: 16px;
  text-align: center;

  .btn {
    min-width: 220px;
  }

  @media (max-width: 576px) {
    .btn {
      width: 100%;
      min-width: unset;
    }
  }
`;

export const HelperBelow = styled.div`
  margin-top: 8px;
  font-size: 12.5px;
  color: #667085;
`;